
import { WorldCountry } from '../types';
import { pakistanExpanded } from './pakistanExpansion';
import { bangladeshExpanded } from './bangladeshExpansion';

export const southAsiaExpansion: WorldCountry[] = [
  pakistanExpanded,
  bangladeshExpanded
];
